import {DevicesState} from './devices';
import {GroupsState} from './groups';
import {PaymentState} from './payment';
import {UserState} from './user';
import {ModalsState} from '@store/modals';
import {MediaState} from '@store/media';
import {PlaylistsState} from '@store/playlists';
import {ScheduleState} from '@store/schedule';
import {DashboardState} from '@store/dashboard';
import {LoaderState} from '@store/loader';
import {FallbackState} from '@store/fallback';
import {SharedDevicesState} from '@store/shared-devices';
import {CampaignsState} from '@store/campaigns';
import {BillingState} from '@store/billing';
import {ShareDeviceFormState} from '@store/share-device-form';
import {ReportDevicesTabState, ReportGroupTabState, ReportState, ReportPlaylistsState} from '@store/report';
import {ModalHotPlaylistsState, ModalMediaState} from '@store/modals-state';
import {ManagePlaylistsState} from '@store/manage-playlists';
import {OutdatedDevicesState} from '@store/oudated-devices';
import {HotPlaylistsState} from '@store/hot-playlists';
import {SidebarHotPlaylistsState, SidebarPlaylistsState} from '@store/sidebar-state';
import {AuditState} from '@store/audit';

export * from './devices';
export * from './user';
export * from './payment';
export * from './groups';
export * from './modals';
export * from './media';
export * from './playlists';
export * from './schedule';
export * from './dashboard';
export * from './loader';
export * from './fallback';
export * from './shared-devices';
export * from './campaigns';
export * from './billing';
export * from './share-device-form';
export * from './report';
export * from './manage-playlists';
export * from './oudated-devices';
export * from './hot-playlists';
export * from './sidebar-state';
export * from './audit';

export const dwallState = [
    AuditState,
    DevicesState,
    GroupsState,
    PaymentState,
    UserState,
    ModalsState,
    MediaState,
    PlaylistsState,
    ScheduleState,
    DashboardState,
    LoaderState,
    FallbackState,
    SharedDevicesState,
    CampaignsState,
    BillingState,
    ShareDeviceFormState,
    ReportDevicesTabState,
    ReportGroupTabState,
    ReportState,
    ReportPlaylistsState,
    ModalMediaState,
    ManagePlaylistsState,
    OutdatedDevicesState,
    ModalHotPlaylistsState,
    HotPlaylistsState,
    SidebarPlaylistsState,
    SidebarHotPlaylistsState
];
